/***
 * @file:ç»å½æå¡
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SettingsService } from '@ithinkdt/shared/browser';
import { BaseAjaxService } from '@ithinkdt/shared/http';

import { API } from '../api/api';

@Injectable({
  providedIn: 'root',
})
export class AuthFetchService extends BaseAjaxService {
  constructor(private settings: SettingsService, http: HttpClient) {
    super(http);
  }

  // åæ this.settings.userConfig.env.serverName.auth +
  // æ¯ä¸ºäºå¼å®¹åå§åä¹åæ´æ¹serverName
  login(param?): Observable<any> {
    return this.post(API.login, param);
  }

  getUser(): Observable<any> {
    return this.post(this.settings.userConfig.env.serverName.auth + API.getUser);
  }

  getMenuAndAcess(appId?: object): Observable<any> {
    return this.post(this.settings.userConfig.env.serverName.auth + API.getMenuAndAcess, appId);
  }

  getAllTenantId(): Observable<any> {
    return this.post(`${this.settings.userConfig.env.serverName.auth}${API.getAllTenantId}`);
  }
}
